"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FunctionOrNode_1 = require("../FunctionOrNode");
var IdentityContext_1 = require("../IdentityContext");
exports.WithCustomPermission = function (_a) {
    var permission = _a.permission, children = _a.children, fallback = _a.fallback;
    return (React.createElement(IdentityContext_1.IdentityConsumer, null, function (user) {
        if (permission(user)) {
            return React.createElement(FunctionOrNode_1.FunctionOrNode, null, children);
        }
        return React.createElement(FunctionOrNode_1.FunctionOrNode, null, fallback);
    }));
};
